<template>
  <div class="productImageItem">
    <AdvancedImage
      :is-lazy-component="false"
      :src="product.src"
      :alt="product.alt"
      :config="productConfig"
    />
  </div>
</template>

<script>
import AdvancedImage from 'Components/01-atoms/advanced-image/AdvancedImage';

export default {
  name: 'ProductImageItem',
  components: { AdvancedImage },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      productConfig: {
        q: 80,
        w: 500,
      },
    };
  },
};
</script>

<style scoped lang="scss">
.productImageItem {
  width: 100%;
  height: 100%;
  max-height: 60vh;
}
</style>
